import moment from 'moment'
import store from '@/store'
import { Debounce } from '@/core/decorator'
import {saveFrontLog} from "@/api/commonConfig";
import getBrowserInfo from 'get-browser-info'

interface log {
  // [key: string]: any
  file: string,
  name: string,
  type: string,
  createTime?: string,
}

// 存储日志
export class Log {
  logList
  isEnd = false

  constructor (log: log) {
    localStorage.setItem('logs', '[]')
    this.logList = JSON.parse(localStorage.getItem('logs') || '[]')
    this.setLog(log)
  }

  setLog (log: log) {
    console.log(this.isEnd, 'setLog -------- ', log)
    if (this.isEnd) return
    // if (log.type === '记录结束') {
    //   this.isEnd = true
    // }
    log = {
      ...log,
      createTime: moment().format('YYYY-MM-DD HH:mm:ss')
    }
    this.logList.push(log)
    localStorage.setItem('logs', JSON.stringify(this.logList))
    this.getLog()
  }

  @Debounce(5000)
  getLog () {
    let user = {
      mobile: store.state.user.mobile,
      companyId: store.state.user.info.companyId,
      loginName: store.state.user.info.loginName,
      partnerCompanyId: store.state.user.info.partnerCompanyId,
    }
    this.logList = JSON.parse(localStorage.getItem('logs') || '[]')
    // return this.logList
    let params = {
      fullPath: decodeURIComponent(window.location.href),
      routeUrl: '/mall',
      exceptionType: 'mallLog',
      userId: store.state.user.userId,
      token: store.state.user.token,
      exceptionMsg: JSON.stringify([user, ...this.logList]),
      browserType: getBrowserInfo().browser,
      browserVersion: getBrowserInfo().browserVersion
    }
    saveFrontLog(params).then(res => {
      localStorage.setItem('logs', '[]')
      this.logList = JSON.parse(localStorage.getItem('logs') || '[]')
    })
  }
}